import { Fade, IconButton, Typography } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'
import React, { useEffect, useState } from 'react'

import { getTranslate } from '../../localization'
import { RoomTypeBrief, RoomTypeFilters } from '../../types/roomtype'
import RoomtypeRow from './RoomtypeRow'
import RoomtypeRowSkeleton from './RoomtypeRow.skeleton'
import useStyles from './styles/RoomtypesTable.styles'

interface RoomtypesTableProps {
  data: RoomTypeBrief[]
  hasAccessToViewRoomTypeTabs: boolean | undefined
  loading: boolean
  reloadData: () => void
  isRoleAdmin: boolean
  setFilters: React.Dispatch<React.SetStateAction<RoomTypeFilters>>
}

export const RoomtypesTable: React.FC<RoomtypesTableProps> = ({
  data,
  hasAccessToViewRoomTypeTabs,
  loading,
  reloadData,
  isRoleAdmin,
  setFilters
}) => {
  const classes = useStyles()
  const [page, setpage] = useState(1)
  const [perPage, setperPage] = useState(6)

  useEffect(() => {
    setpage(0)
    setperPage(10)
  }, [page, perPage])

  return (
    <div className={classes.root}>
      <div
        className={[
          classes.tableHead,
          isRoleAdmin ? classes.tableHeadAdmin : ''
        ].join(' ')}>
        <div>
          <Typography variant="body1">{getTranslate('Name')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Code')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Type')}</Typography>
        </div>
        <div>
          <Typography variant="body1">
            {getTranslate('Default Occupancy')}
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            {getTranslate('Max Occupancy')}
          </Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Total Room')}</Typography>
        </div>
        {isRoleAdmin && (
          <>
            <div>
              <Typography variant="body1">{getTranslate('Deleted')}</Typography>
            </div>
            <div>
              <Typography variant="body1">
                {getTranslate('Deactive')}
              </Typography>
            </div>
          </>
        )}
        <div className={classes.refreshButtonContainer}>
          <IconButton
            onClick={() => {
              reloadData()
              setFilters({
                type: 'all',
                existing: 'all',
                activation: 'all'
              })
            }}>
            <RefreshIcon fontSize="small" />
          </IconButton>
        </div>
      </div>
      {loading
        ? Array(5)
            .fill(null)
            .map((_, index) => (
              <RoomtypeRowSkeleton
                key={`roomtype-skeleton${index.toString()}`}
                isRoleAdmin={isRoleAdmin}
              />
            ))
        : data.map((singleRoomType, index) => (
            <Fade in timeout={600} key={index}>
              <div>
                <RoomtypeRow
                  data={singleRoomType}
                  hasAccessToViewRoomTypeTabs={hasAccessToViewRoomTypeTabs}
                  isRoleAdmin={isRoleAdmin}
                />
              </div>
            </Fade>
          ))}
    </div>
  )
}
